import React, { useEffect, useMemo, useState } from 'react';
import { Avatar, Badge, Tooltip } from '@mui/material';
import { ImageIcon } from '../hf-styled-components/ImageIcon';

interface HFAvatarProps {
    name?: string;
    image?: string;
    badgeImage?: string;
    showName?: boolean;
    size?: 'small' | 'medium' | 'large' | 'xsmall';
    showPopover?: boolean;
}


const HFAvatar: React.FC<HFAvatarProps> = ({
    name,
    image,
    badgeImage,
    showName = false,
    showPopover = false,
    size = 'small'
}) => {

    const [shortName, setShortName] = useState<string>('');

    useEffect(() => {
        if (name) {
            setShortName(name
                ? name.split(' ').map((n) => n[0]).join('').substring(0, 2).toUpperCase()
                : '?');
        }
    }, [name]);

    const avatarSize = useMemo(() => {
        switch (size) {
            case 'xsmall':
                return 24;
            case 'small':
                return 36;
            case 'medium':
                return 48;
            case 'large':
                return 96;
            default:
                return 36;
        }
    }, [size]);


    const avatarContent = badgeImage ? (
        <Badge
            overlap='circular'
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={<ImageIcon size='sm' src={badgeImage} />}
        >
            <Avatar
                alt={name}
                src={!showName ? image : undefined}
                sx={{ width: avatarSize, height: avatarSize }}
            >
                {(!image || showName) && shortName}
            </Avatar>
        </Badge>
    ) : (
        <Avatar
            alt={name}
            src={!showName ? image : undefined}
            sx={{ width: avatarSize, height: avatarSize }}
        >
            {(!image || showName) && shortName}
        </Avatar>
    );

    if (showPopover && name) {
        return (
            <Tooltip title={name} arrow placement='top'>
                {avatarContent}
            </Tooltip>
        );
    }

    return avatarContent;
};

export default HFAvatar;

